import { render, staticRenderFns } from "./IgFooter.vue?vue&type=template&id=b534d3e0&"
import script from "./IgFooter.vue?vue&type=script&lang=ts&"
export * from "./IgFooter.vue?vue&type=script&lang=ts&"
import style0 from "./IgFooter.vue?vue&type=style&index=0&id=b534d3e0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports